import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import GlobalConfigService from "../services/GlobalConfigService";

export const GlobalConfigContext = createContext("GlobalConfigContext");

const GlobalConfigContextProvider = ({ children }) => {
	const [globalConfigList, setGlobalConfigList] = useState([]);
	const [totalElements, setTotalElements] = useState(0);
	const [loadingGlobalConfigList, setLoadingGlobalConfigList] =
		useState(false);
	const [globalConfigListErrorMsg, setGlobalConfigListErrorMsg] =
		useState("");

	const getGlobalConfigList = async (params) => {
		setLoadingGlobalConfigList(true);
		setGlobalConfigListErrorMsg("");
		try {
			const response =
				await GlobalConfigService.getGlobalConfigList(params);
			setGlobalConfigList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setGlobalConfigListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingGlobalConfigList(false);
		}
	};

	return (
		<GlobalConfigContext.Provider
			value={{
				getGlobalConfigList,
				globalConfigList,
				totalElements,
				loadingGlobalConfigList,
				globalConfigListErrorMsg,
			}}
		>
			{children}
		</GlobalConfigContext.Provider>
	);
};

export default GlobalConfigContextProvider;
